import React, { useState, useEffect } from 'react';
import '../AddToHomeScreen.css';

function AddToHomeScreen() {
  const [showPrompt, setShowPrompt] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    // Check if app is already installed (running as PWA)
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || 
                        window.navigator.standalone || 
                        document.referrer.includes('android-app://');

    if (isStandalone) {
      // App is installed, don't show prompt
      setShowPrompt(false);
      return;
    }

    // Check if iOS
    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    setIsIOS(iOS);

    // Check if user has already dismissed
    const hasSeenPrompt = localStorage.getItem('a2hs-dismissed');
    if (hasSeenPrompt) {
      return;
    }

    // Show prompt after a short delay
    setTimeout(() => {
      setShowPrompt(true);
    }, 1000);

    // Listen for beforeinstallprompt event (Android)
    const handleBeforeInstall = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstall);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstall);
    };
  }, []);

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      // Android - use native prompt
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      
      if (outcome === 'accepted') {
        setShowPrompt(false);
      }
      setDeferredPrompt(null);
    }
    // For iOS, user needs to follow manual instructions
  };

  if (!showPrompt) {
    return null;
  }

  return (
    <div className="a2hs-overlay">
      <div className="a2hs-modal">
        <div className="a2hs-icon">
          📱
        </div>
        
        <h2 className="a2hs-title">Install Stranger</h2>
        <p className="a2hs-subtitle">
          This app requires installation to use
        </p>

        {isIOS ? (
          <div className="a2hs-instructions">
            <div className="a2hs-step">
              <div className="step-number">1</div>
              <div className="step-text">
                Tap the <strong>three dots (•••)</strong> in the bottom right
              </div>
            </div>
            <div className="a2hs-step">
              <div className="step-number">2</div>
              <div className="step-text">
                Tap <strong>"Share"</strong> 
                <span className="ios-share-icon">⎋</span>
              </div>
            </div>
            <div className="a2hs-step">
              <div className="step-number">3</div>
              <div className="step-text">
                Scroll down and tap <strong>"Add to Home Screen"</strong>
                <span className="ios-add-icon">➕</span>
              </div>
            </div>
            <div className="a2hs-step">
              <div className="step-number">4</div>
              <div className="step-text">
                Tap <strong>"Add"</strong> in the top right
              </div>
            </div>
          </div>
        ) : (
          <button className="a2hs-install-btn" onClick={handleInstallClick}>
            Install App
          </button>
        )}

        {/* No dismiss button - app requires installation */}

        <div className="a2hs-animation">
          <div className="phone-outline">
            <div className="phone-screen">
              <div className="app-icon">S</div>
              <div className="app-name">Stranger</div>
            </div>
          </div>
          <div className="arrow-down">↓</div>
        </div>
      </div>
    </div>
  );
}

export default AddToHomeScreen;
